var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.value === true)?_c('font-awesome-icon',{staticClass:"text-success",attrs:{"icon":"check-circle","size":"lg"}}):_vm._e(),(_vm.value === false)?_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":"times-circle","size":"lg"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }